module.exports = __webpack_public_path__ + "img/intro-bg-3.d6d04498.jpg";